import { render, staticRenderFns } from "./help_center.vue.js?vue&type=template&id=46f35168&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center.vue?vue&type=template&id=46f35168&vue3"
import script from "./help_center.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center.vue?vue&type=script&lang=js&vue3"
export * from "./help_center.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports